import type { IFilterPanelBaseFilterDeps, IFilterPanelBaseFilterModel } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";

import type { IAppsIosCategoryDescriptionDto } from "../../types/descriptionDto";
import type { IAppsIosCategoryFilter } from "../../types/iosFiltersDto";

export default class FindAppsCategoryFilter
    extends FilterPanelBaseFilter<IAppsIosCategoryFilter, IAppsIosCategoryDescriptionDto>
    implements IFilterPanelBaseFilterModel<IAppsIosCategoryFilter, IAppsIosCategoryDescriptionDto>
{
    constructor(deps: IFilterPanelBaseFilterDeps<IAppsIosCategoryFilter, IAppsIosCategoryDescriptionDto>) {
        super(deps);
    }

    isFilterDirty(currentValue: IAppsIosCategoryFilter | undefined): boolean {
        return Boolean(currentValue?.values && currentValue?.values.length > 0);
    }
}
